import ApiService from '@/services/core/api.service'

const ActivityService = {
  async get (query) {
    return ApiService.get(`dsm/activities?${query}`)
  },

  async post (payload) {
    return ApiService.post('dsm/activities', payload)
  },

  async put (payload) {
    return ApiService.put(`dsm/activities/${payload.id}`, payload)
  }
}

export default ActivityService
